import { Link } from 'react-router-dom';
import { ChevronRight, Bike, Package, Cog, Disc, Shirt, HeadsetIcon } from 'lucide-react';

const categories = [
  {
    id: 'motorcycle',
    label: 'Motorcycle',
    icon: Bike,
    path: '/shop',
    description: 'Browse all motorcycle parts',
  },
  {
    id: 'used-parts',
    label: 'Used Parts',
    icon: Package,
    path: '/shop?condition=Used+%E2%80%93+Normal+Use',
    description: 'Quality used components',
  },
  {
    id: 'new-parts',
    label: 'New Parts',
    icon: Cog,
    path: '/shop?condition=New',
    description: 'Brand new replacements',
  },
  {
    id: 'tires',
    label: 'Tires',
    icon: Disc,
    path: '/shop?partCategory=Tire',
    description: 'All sizes and brands',
  },
  {
    id: 'accessories',
    label: 'Accessories',
    icon: HeadsetIcon,
    path: '/shop?partType=Accessories',
    description: 'Enhance your ride',
  },
  {
    id: 'apparel',
    label: 'Apparel',
    icon: Shirt,
    path: '/shop?partType=Apparel',
    description: 'Riding gear & clothing',
  },
];

export default function CategoryGrid() {
  return (
    <section className="w-full py-8 md:py-12">
      <div className="container px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-6 md:mb-8">
          Shop for Motorcycles
        </h2>

        {/* Mobile: Vertical list with icons */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((category) => {
            const Icon = category.icon;
            return (
              <Link
                key={category.id}
                to={category.path}
                className="group flex flex-col items-center text-center p-4 md:p-6 bg-background border border-border rounded-lg hover:border-foreground hover:shadow-md transition-all duration-200"
              >
                <div className="mb-3 md:mb-4 p-3 md:p-4 bg-muted rounded-full">
                  <Icon className="h-6 w-6 md:h-8 md:w-8 text-foreground" />
                </div>
                <h3 className="font-semibold text-sm md:text-base text-foreground mb-1 group-hover:text-foreground/80">
                  {category.label}
                </h3>
                <p className="text-[10px] md:text-xs text-muted-foreground hidden md:block">
                  {category.description}
                </p>
                <ChevronRight className="h-4 w-4 mt-2 text-muted-foreground group-hover:text-foreground transition-colors" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}